import { useRedirectToMainPortal } from "@hooks/useRedirectToMainPortal";

type RedirectToMainPortalProps = {
  children: JSX.Element;
};

export const RedirectToMainPortal = ({
  children,
}: RedirectToMainPortalProps): JSX.Element | null => {
  const shouldRedirect = useRedirectToMainPortal();

  if (shouldRedirect) {
    return null;
  }

  return children;
};
